<template lang="pug">
  el-popover(
    v-model="visible"
    trigger="manual"
    placement="left-start"
    :width="430"
    popper-class="aml-report-popover"
  )
    .aml-report-popover__content(
      @mouseenter="cancelClose"
      @mouseleave="scheduleClose"
    )
      .aml-report-popover__header
        strong AML-отчёт
        el-button(
          v-if="pinned"
          type="text"
          icon="el-icon-close"
          title="Закрыть"
          aria-label="Закрыть"
          @click="close"
        )
      aml-report-details(:report="report")
      .aml-report-popover__footer
        el-button(
          size="mini"
          type="primary"
          icon="el-icon-document"
          @click="openHistory"
        ) История проверок
    .aml-report-reference(
      slot="reference"
      tabindex="0"
      role="button"
      :title="riskLevel || ''"
      @mouseenter="openFromHover"
      @mouseleave="scheduleClose"
      @focus="openFromHover"
      @blur="scheduleClose"
      @click.stop="pin"
      @keydown.enter.prevent="pin"
      @keydown.space.prevent="pin"
    )
      span.aml-report-reference__score(:style="riskStyle(analysisRisk)") {{ formatPercent(score) }}
      span.aml-report-reference__time {{ formatDate(report.checkedAt, true) }}
</template>

<script>
import AmlReportDetails from '@/components/AmlReportDetails.vue';
import {
  amlRiskStyle,
  formatAmlDate,
  formatAmlPercent,
} from '@/utils/aml';

export default {
  name: 'AmlReportPopover',
  components: { AmlReportDetails },
  props: {
    address: {
      type: String,
      required: true,
    },
    report: {
      type: Object,
      required: true,
    },
    score: {
      type: Number,
      default: 0,
    },
    riskLevel: {
      type: String,
      default: '',
    },
    analysisRisk: {
      type: String,
      default: 'unknown',
    },
  },
  data() {
    return {
      visible: false,
      pinned: false,
      closeTimer: null,
    };
  },
  beforeDestroy() {
    this.cancelClose();
  },
  methods: {
    formatDate: formatAmlDate,
    formatPercent: formatAmlPercent,
    riskStyle: amlRiskStyle,
    openFromHover() {
      this.cancelClose();
      this.visible = true;
    },
    pin() {
      this.cancelClose();
      this.pinned = true;
      this.visible = true;
    },
    close() {
      this.cancelClose();
      this.pinned = false;
      this.visible = false;
    },
    cancelClose() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },
    scheduleClose() {
      if (this.pinned) {
        return;
      }
      this.cancelClose();
      this.closeTimer = setTimeout(() => {
        this.visible = false;
        this.closeTimer = null;
      }, 180);
    },
    openHistory() {
      this.close();
      this.$router.push({
        name: 'AmlReports',
        params: { address: this.address },
      });
    },
  },
};
</script>

<style scoped>
.aml-report-popover__header,
.aml-report-popover__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.aml-report-popover__header {
  min-height: 32px;
  border-bottom: 1px solid #ebeef5;
}

.aml-report-popover__footer {
  justify-content: flex-end;
  padding-top: 10px;
}

.aml-report-reference {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  outline: none;
}

.aml-report-reference:focus .aml-report-reference__score {
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.25);
}

.aml-report-reference__score {
  display: inline-block;
  min-width: 64px;
  padding: 4px 8px;
  border: 1px solid;
  border-radius: 4px;
  text-align: center;
}

.aml-report-reference__time {
  color: #909399;
  font-size: 11px;
  white-space: nowrap;
}
</style>

<style>
.aml-report-popover {
  box-sizing: border-box;
  max-width: calc(100vw - 24px);
}
</style>
